import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatNumber = (num) => {
  if (num === undefined || num === null) return '0';
  return new Intl.NumberFormat('de-DE').format(num);
};

export const formatEuro = (num) => {
  if (num === undefined || num === null) return '0,00 \u20AC';
  return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(num);
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

export const formatDateShort = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
};

export const formatWeekday = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('de-DE', { weekday: 'short' });
};

export const CATEGORY_LABELS = {
  produktion: 'Produktion', administration: 'Administration',
  recherche: 'Vertrieb', cold_calls: 'Cold Calls',
  ordnung: 'Ordnung', gesundheit: 'Gesundheit',
  sein: 'Sein', lernen: 'Lernen',
};

export const CATEGORY_DESCRIPTIONS = {
  produktion: 'Projektarbeit, Umsetzung, Gestaltung',
  administration: 'E-Mails, Rechnungen, Organisation',
  recherche: 'Vertrieb, Lead-Recherche, Vorbereitung',
  cold_calls: 'Telefonakquise inkl. Gespraechszeit',
  ordnung: 'Putzen, Aufraeumen, Einkaufen',
  gesundheit: 'Training, Pflege, Regeneration',
  sein: 'Kochen, Essen, Grundversorgung',
  lernen: 'Weiterbildung (keine Punkte)',
};

export const TIME_POINTS = {
  produktion: 35, administration: 12, recherche: 12,
  cold_calls: 18, ordnung: 15, gesundheit: 12, sein: 8,
};

export const SALES_LABELS = {
  leads: 'Leads recherchiert', cold_calls_done: 'Cold Calls durchgefuehrt',
  direkt_aus_cold_calls: 'Erstgespraeche waehrend Cold Calls',
  kontaktdaten_gesendet: 'Kontaktdaten gesendet',
  erstgespraech_gefuehrt: 'Erstgespraeche gefuehrt',
  erstgespraech_gebucht: 'Erstgespraeche gebucht',
  angebot_angefordert: 'Angebot angefordert',
  angebot_gesendet: 'Angebot gesendet',
  follow_up: 'Follow-up', zusage: 'Zusage / Auftrag',
  anzahlung: 'Anzahlung erhalten',
  teilzahlung_2: '2. Teilzahlung', restzahlung: 'Restzahlung',
};

export const SALES_POINTS = {
  leads: 1, cold_calls_done: 1, direkt_aus_cold_calls: 0,
  kontaktdaten_gesendet: 2,
  erstgespraech_gefuehrt: 15, erstgespraech_gebucht: 8,
  angebot_angefordert: 8, angebot_gesendet: 12, follow_up: 2,
  zusage: 100, anzahlung: 200, teilzahlung_2: 120, restzahlung: 80,
};

export const CATEGORY_COLORS = {
  produktion: '#38BDF8', administration: '#10B981',
  recherche: '#EAB308', cold_calls: '#F43F5E',
  ordnung: '#8B5CF6', gesundheit: '#06B6D4', sein: '#F97316',
};
